import http from './http'

export default {
  list: () => http.get('/v2/import'),
  start: type => http.post(`/v2/import/${type}`),
  getStatus: type => http.get(`/v2/import/${type}/status`),
  resetStatus: type => http.delete(`/v2/import/${type}/status`),
  downloadResult: type => http.get(`/v2/import/${type}/download`, { responseType: 'blob' })
}



// WEBPACK FOOTER //
// ./src/services/api/import.js